
import { sound } from '@pixi/sound'
import { assetList, spriteSize } from './assets';

// Names you use to call spirtes/sounds are the same as filenames, without the extension
// e.g "collect.mp3" can be called by "loader.Sound("collect")"
// e.g "hero.png" can be called by "loader.Sprite("hero")"

class Loader {
    constructor() {
        //this.sounds = config.soundLoader
        this.resources = {};
        this.charSprite = {};
    }

    async preload() {
        try {
                await Promise.all(
                    assetList.map(async (fileModule) => {
                        let filePath = fileModule;
                        // console.log(filePath);
                        const texture = await PIXI.Assets.load(filePath);
                        const indexOfSlash = filePath.lastIndexOf('/')
                        filePath = filePath.substring(indexOfSlash + 1)
                        const indexOfDot = filePath.lastIndexOf('.');

                        const
                            extension = filePath.substring(indexOfDot + 1),
                            fileName = filePath.substring(0, indexOfDot);

                        if (extension.toLowerCase() === 'mp3') {
                            if (sound.exists(fileName)) {
                                sound.remove(fileName)
                            }
                            // console.log(sound);
                            sound.add(fileName, {
                                url: fileModule,
                                useXHR: true,
                            }); // You can then call files using Pixi's sound system (`sound(name).play()`)
                        }
                        else {
                            this.resources[fileName] = texture; // Store loaded textures
                        }
                    })
              );
        } catch (error) {
            console.error("Error loading assets:", error);
        }
    }

    SpriteSize(key) {
        let size = spriteSize[key];
        return size;
    }
    Sprite(key) {
        let size = spriteSize[key];
        let tile = new PIXI.Sprite(this.resources[key]);
        [tile.width, tile.height] = [size.x, size.y];
        return tile;
    }

    Sound(key) {
        return sound.find(key);
    }
}

export const loader = new Loader();